import React from 'react';
import * as Fi from 'react-icons/fi';
import { BiAddToQueue } from 'react-icons/bi';
import cn from 'classnames';
import {
  Button,
  Modal,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  Skeletons,
  SkeletonPageFooter,
} from 'ui/components/skeleton';

import useTable from 'ui/components/table';

import tableConfig from './component/table.config';
import Filter from './component/filter';

import { FormGeneral } from './component/form';

const initialState = {
  displayFilter: false,
  count: [],
  isCreate: false,
};

const CoaScreen = () => {
  const CoaTable = useTable('coa', tableConfig);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  const [{ displayFilter, count, isCreate }, setState] =
    React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({...prevState, isCreate: false}));
  };

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        title={'Coa'}
        isLoading={StateLoading}
      >
        <button
          onClick={() =>
            setState((prevState) => ({ ...prevState, isCreate: true }))
          }
          className="btn btn-primary py-1 ms-1"
        >
          <BiAddToQueue color="white" size="14" />
          <span className="d-none d-md-block ms-2">
            Tambah Coa Baru
          </span>
        </button>
      </Page.Header>

      <Page.Navigation toolbar>
        <CoaTable.Tools downloadable isLoading={StateLoading}>
          {StateLoading ? (
            <div className="ms-2">
              <Skeletons height="35px" width="50px" />
            </div>
          ) : (
            <Button
              variant={displayFilter ? 'primary' : 'secondary'}
              className="ms-2 position-relative"
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  displayFilter: !displayFilter,
                }))
              }
            >
              <Fi.FiFilter size={19} color="white" />
              {count?.length > 0 ? (
                <span className="position-absolute top-0 start-100 translate-middle badge border border-light rounded-circle bg-danger">
                  {count?.length}
                </span>
              ) : null}
            </Button>
          )}
        </CoaTable.Tools>
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className={cn(
            displayFilter ? 'col-md-9  m-0 p-0' : 'col-md-12   m-0 p-0'
          )}
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <CoaTable.Render />
          )}
        </div>

        <Filter
          CoaTable={CoaTable}
          onClose={() =>
            setState((prevState) => ({
              ...prevState,
              displayFilter: false,
            }))
          }
          show={displayFilter}
          setCount={(x) =>
            setState((prevState) => ({
              ...prevState,
              count: x,
            }))
          }
        />
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <CoaTable.Pagination />}
      </Page.Footer>

      <Modal
        show={isCreate}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Coa</Modal.Title>
        </Modal.Header>
        <FormGeneral
          onClose={() => {
            $handleClose();
          }}
        />
      </Modal>
    </Page>
  );
};

export default CoaScreen;
